import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { sendStatsToKibana } from '../../../wildix/components/analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../../../wildix/components/analytics/kibana/constants';
import { toggleMetaWildixTranscription } from './actions.any';
/**
 * Listens for changes in transcribing state.
 * Use cases:
 *  - Send metadata "wildixMetadata: {"transcriptionDisabledByUser"}" by Message to all users to disable transcription
 */
// @ts-ignore
StateListenerRegistry.register(state => state['wildix/features/transcribing'].isTranscriptionDisabled, 
/* listener */ (isTranscriptionDisabled, { dispatch, getState }, prevState) => {
    if (isTranscriptionDisabled === null || typeof isTranscriptionDisabled === 'undefined') {
        return;
    }
    const isPbxUser = getState()['features/base/settings']?.ctijid;
    if (isTranscriptionDisabled !== prevState && isPbxUser) {
        dispatch(toggleMetaWildixTranscription(isTranscriptionDisabled));
        // @ts-ignore
        if (isTranscriptionDisabled) {
            dispatch(sendStatsToKibana([{ isTranscriptionDisabled }], KIBANA_MESSAGES.TranscriptionOFF));
        }
    }
});
